<template>
    <div class="container mt-1 mb-1 text-right">
        <a @click="$router.go(-1)" :class="modoDark_var? 'btn DarkActive' : 'btn btn-vino-o'" style="border-radius:22px;"> <!--:to="{name:nombre_ruta}"-->
            <i class="fas fa-arrow-left"></i> Atrás
        </a>
            <!-- <a :href="url_ruta"  type="button" style="border-radius:22px;" class="btn btn-vino-o"><i class="fas fa-arrow-left"></i> Atrás</a> -->
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    props:{
        nombre_ruta:'',
    },
    computed:{
      ...mapState(['modoDark_var'])
    }
}
</script>


<style scoped>

#foprovep a:hover{
    text-decoration: none !important;
    color: #fff !important;
}

/* .DarkAtras{
    color: black;
    background: white;
} */



</style>
